import { parseJwt } from '../../app/commons/helpers/JWTHelpers';

const TOKEN_PARAM_NAME = 'yp-wr-token';
const CHECK_PRESENCE_PARAM_NAME = 'ypCheckPresence';

function onExpiration() {
    const { searchParams } = new URL(window.location.href);
    searchParams.delete(TOKEN_PARAM_NAME);
    searchParams.set(CHECK_PRESENCE_PARAM_NAME, '1');
    window.location.replace(`${window.location.pathname}?${searchParams.toString()}`);
}

function init() {
    const { searchParams } = new URL(window.location.href);
    if (!searchParams.has(TOKEN_PARAM_NAME)) {
        return;
    }
    let jwtPayload = null;
    try {
        jwtPayload = parseJwt(
            searchParams.get(TOKEN_PARAM_NAME),
        );
    } catch (e) {
        console.error(e);
    }
    if (!jwtPayload) {
        return;
    }
    const expirationDate = jwtPayload.exp * 1000;
    const expirationDelay = Math.max(0, expirationDate - Date.now());
    window.setTimeout(onExpiration, expirationDelay);
}

window.addEventListener('load', init);
